export const TOURS = {
    HABITS: 1,
    PATHWAYS: 2,
    JFY: 3,
    TEAMMATES: 4,
    PROFILE: 5,
    FEATURED: 6,
    TILES: 7,
    COACH: 8
};